export default __webpack_public_path__ + "static/media/top1-bg.374a0dda.webp";